import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { resetAuth } from '../../../store/authState.ts'
import { useSnapshot } from 'valtio'
import { controlState, resetControl } from '../../../store/controlState.ts'
import { dataState, resetData } from '../../../store/dataState.ts'
import { resetHistory } from '../../../store/historyState.ts'
import { mapState, resetMap } from '../../../store/mapState.ts'
import { createPortal } from 'react-dom'
import { MapSettingsPanel } from '../../map/mapSettings/MapSettingsPanel.tsx'
import { safeZoneState } from '../../../store/safeZoneState.ts'
import { SafeZonePanel } from '../../safeZones/SafeZonePanel.tsx'

interface Props {
	menuAction: (a: string, s?: any) => void
}

export const MainMenu: React.FC<Props> = (props) => {
	const {menuAction} = props
	const navigate = useNavigate()
	const isMobile = useSnapshot(controlState).isOnMobileDevice
	const showMapStyle = (useSnapshot(mapState) as typeof mapState).showMapStyle
	const showSafeZonPanel = (useSnapshot(safeZoneState) as typeof safeZoneState).active
	const color = 'primary'
	const pets = (useSnapshot(dataState) as typeof dataState).pets

	const logout = () => {
		resetAuth()
		resetData()
		resetMap()
		resetHistory()
		resetControl()
		localStorage.removeItem('gibi')
		localStorage.removeItem('gibiUser')
		navigate('/')
	}

	const label = (
		<div className="prose text-left flex flex-col justify-start gap-3 p-4">
			<div>
				<h2 className={`text-${color} mb-0 mt-0`}>Main menu</h2>
			</div>
		</div>
	)

	const size = !isMobile ? '' : 'w-[80vw]'
	return (
		<div
			className={`flex flex-col justify-center item-center gap-4 bg-white p-6 rounded-md shadow-lg text-${color} ${size}`}
			data-theme={'gibi'}>
			{label}

			<div onClick={() => menuAction('/pets', {pet: pets?.[0]})}>
				<button className={`btn btn-wide btn-${color} w-full text-lg`}>
					<span>
						Edit Pets
						<FontAwesomeIcon icon={faChevronRight} className={'ml-2'}/>
					</span>
				</button>
			</div>

			<div onClick={() => menuAction('/trackers')}>
				<button className={`btn btn-wide btn-${color} w-full text-lg`}>
					<span>
						Gibi Trackers
						<FontAwesomeIcon icon={faChevronRight} className={'ml-2'}/>
					</span>
				</button>
			</div>

			<div onClick={() => menuAction('/contacts')}>
				<button className={`btn btn-wide btn-${color} w-full text-lg`}>
					<span>
						Contacts
						<FontAwesomeIcon icon={faChevronRight} className={'ml-2'}/>
					</span>
				</button>
			</div>

			<div onClick={() => menuAction('/profile')}>
				<button className={`btn btn-wide btn-${color} w-full text-lg`}>
					<span>
						Profile
						<FontAwesomeIcon icon={faChevronRight} className={'ml-2'}/>
					</span>
				</button>
			</div>

			<div className={`divider divider-${color} m-0`}></div>

			<div onClick={() => {
				controlState.menuOpen = false
				navigate('/map')
				setTimeout(() => safeZoneState.active = true)
			}
			}>
				<button className={`btn btn-wide btn-${color} btn-outline w-full text-lg`}>
					<span>
						Safe Zones
					</span>
				</button>
			</div>

			<div className={`divider divider-${color} m-0`}></div>

			<div onClick={() => {
				controlState.menuOpen = false
				mapState.showMapStyle = true
			}
			}>
				<button className={`btn btn-wide btn-${color} btn-outline w-full text-lg`}>
					<span>
						Map Style
					</span>
				</button>
			</div>

			<div onClick={() => window.open('https://getgibi.com/FAQ', '_blank', 'noreferrer')}>
				<button className={`btn btn-wide btn-${color} btn-outline w-full text-lg`}>
					<span>
						Gibi Tracker FAQ
					</span>
				</button>
			</div>

			<div className={`divider divider-${color} m-0`}></div>

			<div onClick={() => logout()}>
				<button className={`btn btn-wide btn-neutral text-lg`}>Logout</button>
			</div>

			<div className={'text-xs text-neutral-content/50 mt-4'}>
				<span>Build </span><span>{import.meta.env.VITE_REACT_APP_VERSION}</span>
			</div>

			{showMapStyle ? createPortal(<MapSettingsPanel
				close={() => mapState.showMapStyle = false}/>, document.body) : null}
			{isMobile && showSafeZonPanel ? createPortal(<SafeZonePanel
				close={() => safeZoneState.active = false}/>, document.body) : null}

		</div>
	)
}
